import AxiosClient from "../AxiosClient";

// fax送信API
export const postSendMailApi = (params) => {
  return AxiosClient.post("/api/mail/sendMail", params);
}